/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-23 21:06:59
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/checkbox.js
 */
export default {
    // checkbox组件
    checkbox: {
        name: '',
        shape: '',
        size: '',
        checkbox: false,
        disabled: '',
        activeColor: '',
        inactiveColor: '',
        iconSize: '',
        iconColor: '',
        label: '',
        labelSize: '',
        labelColor: '',
        labelDisabled: ''
    }
}
